import React from 'react';

class Snackbar extends React.Component {
    constructor (props) {
        super(props)
        this.state = this.props.store();
    }

    componentWillMount () {
        var self = this;
        this.removeListener = this.props.store(function onChange (state) {
            self.setState(state);
        });
    }

    componentWillUnmount () {
        this.removeListener();
    }

    render () {
        var cl = 'snackbar' + (this.state.message ? ' active' : ' inactive');
        var typeCl = 'snackbar-type ' + 'snackbar-' + this.state.type;
        var typeEl = this.state.type && this.state.message ?
            (<span className={typeCl}>
                {this.state.type.charAt(0).toUpperCase() +
                    this.state.type.slice(1)}: </span>) :
            null
        ;

        return (
            <div className={cl}>
                {typeEl}
                {this.state.message}
            </div>
        );
    }
}

export default Snackbar;
